import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Eye, Edit, Trash2 } from 'lucide-react';
import { useApp } from '../../context/AppContext';

const CollectionCard = ({ collection }) => {
  const { deleteCollection } = useApp();

  const handleDelete = (e) => {
    e.preventDefault();
    if (window.confirm(`Are you sure you want to delete "${collection.name}"? This will also delete all products in this collection.`)) {
      deleteCollection(collection.id);
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow overflow-hidden group">
      {/* Image */}
      <div className="relative">
        <img 
          src={collection.image} 
          alt={collection.name}
          className="w-full h-48 object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-200" />
        
        {/* Action buttons */}
        <div className="absolute top-2 right-2 flex space-x-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <Link
            to={`/products/${collection.id}`}
            className="p-2 bg-white rounded-lg shadow-sm hover:bg-gray-50 transition-colors"
            title="View Products"
          >
            <Eye size={16} className="text-gray-600" />
          </Link>
          <Link
            to={`/edit-collection/${collection.id}`}
            className="p-2 bg-white rounded-lg shadow-sm hover:bg-gray-50 transition-colors"
            title="Edit Collection"
          >
            <Edit size={16} className="text-gray-600" />
          </Link>
          <button
            onClick={handleDelete}
            className="p-2 bg-white rounded-lg shadow-sm hover:bg-red-50 transition-colors"
            title="Delete Collection"
          >
            <Trash2 size={16} className="text-red-600" />
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              {collection.name}
            </h3>
            <p className="text-sm text-gray-600 mb-3 line-clamp-2">
              {collection.description}
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-1 text-gray-500">
            <Package size={16} />
            <span>{collection.productCount} product{collection.productCount !== 1 ? 's' : ''}</span>
          </div>
          <span className="text-gray-400">
            {new Date(collection.createdAt).toLocaleDateString()}
          </span>
        </div>

        {/* View Products Button */}
        <Link
          to={`/products/${collection.id}`}
          className="mt-4 w-full bg-indigo-50 hover:bg-indigo-100 text-indigo-700 py-2 px-4 rounded-lg text-sm font-medium text-center transition-colors block"
        >
          View Products
        </Link>
      </div>
    </div>
  );
};

export default CollectionCard; 